import React from 'react';
import { Modal, QRCode } from 'antd';
import { ButtonCommon } from 'components/common';
import { QRCodeModalProps } from 'types';

const QRCodeModal: React.FC<QRCodeModalProps> = ({ isOpen, onClose, phoneNumber, companyName }) => {
  return (
    <Modal
      open={isOpen}
      // onCancel={onClose}
      footer={null}
      width={682}
      centered
      closeIcon={false}
      className='modal-none-padding'
    >
      <div className='mb-3 py-3 px-6'>
        <h2 className='text-[20px] font-bold leading-[24px]'>QUÉT MÃ ĐỂ LIÊN HỆ ZALO</h2>
        <p className='text-[14px] leading-[20px] text-[var(--textBlack56)]'>
          Vui lòng quét mã bên dưới để liên hệ trực tiếp tới nhà cung cấp
        </p>
      </div>

      <div className='bg-[var(--bgGreyColor)] p-6 rounded-lg flex flex-col items-center'>
        <div className='mb-6'>
          <QRCode size={324} className='p-1' value={`https://zalo.me/${phoneNumber}`} />
        </div>
        <div className='text-[18px] font-bold mb-6 text-center'>{companyName || 'CÔNG TY TNHH TÔN HOA SEN'}</div>

        <div className='flex justify-center gap-6'>
          <ButtonCommon color='none' radius='rounded' onClick={onClose}>
            Trở lại
          </ButtonCommon>

          <ButtonCommon
            color='primary'
            radius='rounded'
            onClick={() => {
              window.open(`https://zalo.me/${phoneNumber}`, '_blank');
            }}
          >
            Nhắn qua Zalo ngay
          </ButtonCommon>
        </div>
      </div>
    </Modal>
  );
};

export default QRCodeModal;
